module.exports = __webpack_public_path__ + "static/media/meetashi.8e754659.webp";